import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

type Props = {
  headerDivider?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardBase',
  props: {
    headerDivider: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "header"),
    _renderSlot(_ctx.$slots, "default"),
    _renderSlot(_ctx.$slots, "footer")
  ]))
}
}

})